export default __webpack_public_path__ + "static/media/kyc_verified.11f6a671.svg";